module.exports = __webpack_public_path__ + "img/tile-rendering-desktop_jp.4f2f5f9.jpg";